/**
 * Visitor Map Route: /{orgSlug}/{mapSlug}
 *
 * On subdomain/custom_domain mode: 301 redirects to /{mapSlug} (clean URL).
 * On dev/admin mode: renders the visitor map directly.
 *
 * TanStack Router prioritizes static segments (e.g., "admin") over dynamic
 * ones ($mapSlug), so this route coexists with /{orgSlug}/admin/* routes.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { detectTenant } from "../hooks/use-tenant";
import { validateVisitorSearch } from "../lib/visitor-search";
import { VisitorMapBySlug } from "../components/visitor/VisitorMapBySlug";

export const Route = createFileRoute("/$orgSlug/$mapSlug")({
  validateSearch: validateVisitorSearch,
  beforeLoad: ({ params, search }) => {
    const tenant = detectTenant();

    // On subdomain/custom_domain mode, redirect old two-segment URLs to clean single-segment.
    // Prevents two URLs serving the same content (SEO).
    if (
      (tenant.mode === "subdomain" || tenant.mode === "custom_domain") &&
      (tenant.orgSlug === null || params.orgSlug === tenant.orgSlug)
    ) {
      throw redirect({
        to: "/$mapSlug",
        params: { mapSlug: params.mapSlug },
        search: search,
        replace: true,
      });
    }
  },
  component: OrgMapRoute,
});

function OrgMapRoute() {
  const { orgSlug, mapSlug } = Route.useParams();
  const search = Route.useSearch();
  return <VisitorMapBySlug orgSlug={orgSlug} mapSlug={mapSlug} search={search} />;
}
